<template>
  <div class="pagination d-flex justify-center" :class="{'dark': dark}">
    <div class="pagination-item" v-if="showNavButtons">
      <button
        :disabled="currentPage === 1"
        :class="['pagination-nav-button', {'disabled': Number(currentPage) === 1}]"
        @click="changePage(currentPage - 1)"
      >
        <span class="icon icon-chevron-left"></span>
      </button>
    </div>
    <div
      v-for="(page, index) in pagesRange"
      :key="index"
      class="pagination-item"
    >
      <a
        :class="['pagination-link', {'active-pagination-link': page === Number(currentPage)}]"
        :href="link ? `${link}?page=${page}` : '#'"
        @click.prevent="changePage(page)"
      >
        {{ page }}
      </a>
    </div>
    <div class="pagination-item" v-if="showNavButtons">
      <button
        :disabled="pagesRange[pagesRange.length -1] == currentPage"
        :class="['pagination-nav-button', {'disabled': pagesRange[pagesRange.length -1] === (Number(currentPage))}]"
        @click="changePage(currentPage + 1)"
      >
        <span class="icon icon-chevron-right"></span>
      </button>
    </div>
  </div>
</template>

<script setup lang="js">
const props = defineProps({
  value: {
    type: Number,
    default: 1
  },
  length: {
    type: Number,
    default: 0
  },
  totalVisible: {
    type: Number,
    default: 5
  },
  link: {
    type: String,
    default: undefined
  },
  dark: {
    type: Boolean,
    default: false
  }
})

const currentPage = computed(() => props.value)
const emit = defineEmits(["change"]);
const changePage = (page) => {
  emit('change', page)
}

const pagesRange = computed(() => {
  let current = props.value
  let min = 1
  let total = props.length
  let length = props.totalVisible

  if (length > total) length = total

  let start = current - Math.floor(length / 2)
  start = Math.max(start, min)
  start = Math.min(start, min + total - length)

  return Array.from({length: length}, (el, i) => start + i)
})

const showNavButtons = computed(() => {
  return pagesRange.value && pagesRange.value.length
})
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  .pagination-item {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 38px;
    font-size: 16px;

    .pagination-link {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      color: #424D63;
      text-decoration: none;
      font-weight: 500;
      font-size: 16px;
      border: 2px solid #E8EEF2;
      &.active-pagination-link {
        background: #1985F9;
        border: 2px solid #1985F9;
        color: #fff;
        font-weight: 500;
        font-size: 16px;
      }
    }

    .pagination-nav-button {
      color: #09B5FF;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 2px solid #E8EEF2;
      font-size: 20px;
      &.disabled {
        background: #E8EEF2;
      }
    }

    .pagination-nav-button:focus,
    .pagination-nav-button:active {
      outline: none;
      box-shadow: none;
    }
  }

  .dark {
    gap: 20px;

    .pagination-item {
      .pagination-nav-button {
        color: #000;
      }
      .pagination-link {
        &.active-pagination-link {
          background: #000;
          border-radius: 6px;
        }
      }
    }
  }
}
</style>
